// extracted by mini-css-extract-plugin
export default {"basket_page":"style_basket_page__g2JUA","container":"style_container__lkmh-","basket_items":"style_basket_items__3v2WQ","link_to_shop":"style_link_to_shop__exR7d"};